/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetEncountersParams, GetEncountersResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncounters = (params?: GetEncountersParams, signal?: AbortSignal) => {
  return api<GetEncountersResponse>({ url: `/api/encounters`, method: 'GET', params, signal });
};

export const getGetEncountersQueryKey = (params?: GetEncountersParams) => {
  return [`/api/encounters`, ...(params ? [params] : [])] as const;
};

export const getGetEncountersQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncountersResponse,
>(
  params?: GetEncountersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncounters>>> = ({ signal }) =>
    getEncounters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncounters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersQueryResult = NonNullable<Awaited<ReturnType<typeof getEncounters>>>;
export type GetEncountersQueryError = GetEncountersResponse;

export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncountersResponse,
>(
  params: undefined | GetEncountersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncounters>>,
          TError,
          Awaited<ReturnType<typeof getEncounters>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncountersResponse,
>(
  params?: GetEncountersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncounters>>,
          TError,
          Awaited<ReturnType<typeof getEncounters>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncountersResponse,
>(
  params?: GetEncountersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncountersResponse,
>(
  params?: GetEncountersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
